import Author from "./Author";
import Ingest from "./Ingest";
import Properties from "./Properties";

export default {
  Author,
  Ingest,
  Properties
};
